<template>
	<div class="system-box" v-loading="loading">
		<p>
			物流信息同步接口配置
		</p>
		<el-form
			:model="form"
			:rules="rules"
			ref="form"
			label-width="auto"
			:inline="true"
		>
			<el-form-item label="用户ID：" prop="business_id">
				<el-input v-model="form.business_id"></el-input>
			</el-form-item>
			<el-form-item label="APP-KEY：" prop="app_key">
				<el-input v-model="form.app_key" style="width:320px"></el-input>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import { kdBirdConfigGet } from '@/api/order'

export default {
	data() {
		return {
			loading: false,
			form: {
				business_id: '',
				app_key: ''
			},
			rules: {}
		}
	},
	created() {
		this.loading = true
		kdBirdConfigGet()
			.then(res => {
				this.form = res
				this.loading = false
			})
			.catch(() => {
				this.loading = false
			})
	},
	methods: {}
}
</script>

<style lang="scss" scoped>
.system-box {
	background-color: #f7f7f7;
	text-align: left;
	padding: 12px;
}
</style>
